<template>
  <div class="out-checkKnows">

    <!-- 已选中的知识点，以tag方式展示——start -->
    <div class="tree-tag-wrap" @click.stop="handleClick">
      <template v-if="question.knowledgePoints && question.knowledgePoints.length > 0">
        <div
          class="knows-scroll-box"
          v-scrollbar
        >
          <el-tag
            :key="index"
            v-for="(tag,index) in question.knowledgePoints"
            closable
            @close="delCheckKnowNode(tag)">
            {{tag.name}}
          </el-tag>
        </div>
        <div class="all-close-btn el-icon-circle-close" @click.stop="clearKnowTree"></div>
      </template>
      <span v-else >请选择知识点</span>
      <i class="el-icon-arrow-down tree-arrow-down" :class="{'is-reverse': showKnowTree}"></i>
    </div>
    <!-- 已选中的知识点，以tag方式展示——end -->

    <!--列举可能相符的知识点——start-->
    <div class="suggest-wrapper" v-if="matchKnowList.length">
      <div class="title" @click="showCheckGroup = !showCheckGroup">可能相符的知识点
        <div class="pull-right">{{ showCheckGroup? '点击收起':'点击查看'}}<i :class="showCheckGroup?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
      </div>
      <div class="list" v-show="showCheckGroup">
        <el-checkbox-group v-model="matchCheckedKnow"  @change="handleMatchKnowChange">
          <el-checkbox v-for="(k,index) in matchKnowList" :label="k" :key="index">{{k.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!--列举可能相符的知识点——end-->

    <!-- 知识点树——开始 -->
    <div class="tree-wrapper" @click.stop="handleClick(true)" v-show="showKnowTree">
      <div class="pl20 pr20">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterKnow"
          clearable>
        </el-input>
      </div>
      <div class="custom-tree">
        <el-tree
          icon-class="icon iconfont icon-znjf-jiahao-xianxing"
          ref="knowTree"
          :data="basicKnowledgePointList"
          show-checkbox
          highlight-current
          :props="defaultProps"
          node-key="id"
          :check-strictly="true"
          @check="handleKnowClick"
          :filter-node-method="filterNode"
        >
          <span class="span-ellipsis" slot-scope="{ node }" :title="node.label">
            {{ node.label }}
          </span>
        </el-tree>
      </div>
    </div>
    <!-- 知识点树——结束 -->
  </div>
</template>

<script>
import { Tag, Tree } from 'element-ui'
import { mapState, mapActions } from 'vuex'
import { deepClone } from '@/utils/tools'
export default {
  name: 'check-knows',
  props: {
    // questionId: {
    //   type: Number,
    //   default: 0
    // },
    question: {
      type: Object
    },
  },
  mounted () {
    // this.initMatchKnow()
    let that = this
    document.addEventListener('click', function (e) {
      that.showKnowTree = false
    })
  },
  data () {
    return {
      filterKnow: '', // 知识点过滤关键词
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      matchCheckedKnow: [], // 勾选中的可能相符的知识点
      matchKnowList: [], // 可能相符的知识点
      showKnowTree: false, // 是否显示知识点树
      showCheckGroup: true // 是否显示可能相符的知识点列表
    }
  },
  computed: {
    ...mapState({
      basicKnowledgePointList (state) {
        let basicKnowledgePointList = deepClone(state.basicDataV3.basicKnowledgePointList)
        this.dealKnowledge(basicKnowledgePointList)
        return basicKnowledgePointList|| [];
      },
      // questionSettingVisible (state) {
      //   return state.paperOut.questionSettingVisible
      // }
    }),
    knowledgePoints () {
      return this.question.knowledgePoints
    }
  },
  watch: {
    // 监听弹窗开启，如果开启，重新获取数据（针对于修改试题属性）
    // questionSettingVisible (newVal, oldVal) {
    //   if (newVal) {
    //     // this.initMatchKnow()
    //   }
    // },
    'filterKnow' (val) {
      this.$refs.knowTree.filter(val)
    },
    'questionId' (val) {
      // 如果题目切换了，清除所有初始数据
      this.filterKnow = ''
      this.showCheckGroup = true
      // // 获取相符的知识点列表
      // this.initMatchKnow()
    },
    'knowledgePoints': {
      handler (val) {
        this.question.knowledgePointId = []
        let that = this
        _.each(val, (item) => {
          that.question.knowledgePointId.push(item.knowledgePointId)
        })
        this.$nextTick(() => {
          this.$refs.knowTree.setCheckedKeys(that.question.knowledgePointId)
        })
      },
      immediate: true
    }
  },
  methods: {
    dealKnowledge(arr) {
      if (!arr) {
        return;
      }
      for(let i = 0; i < arr.length; i++) {
        if (arr[i].children && arr[i].children.length > 0) {
          if (!this.judgeAllLeft(arr[i].children)) {
            arr[i].disabled = true;
          }
          this.dealKnowledge(arr[i].children)
        }
      }
    },
    judgeAllLeft(arr) {
      let res = true;
      for(let j = 0; j < arr.length; j++) {
        if (arr[j].children && arr[j].children.length > 0) {
          res = false;
          break;
        }
      }
      return res;
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 清除所有选择的知识点(el-tag渲染的数据，传给后台的question.knowledgePointId,可能相符的勾选中的)
    clearKnowTree () {
      this.question.knowledgePoints = []
      this.matchCheckedKnow = []
    },
    // 改变框内el-tags选中项（只有删除的改变途径），删除知识点
    delCheckKnowNode (tag) {
      this.question.knowledgePoints.splice(this.question.knowledgePoints.indexOf(tag), 1)
      // this.changeMatchChecked()
    },
    // 改变树选择的知识点
    handleKnowClick (data, node) {
      this.question.knowledgePoints = []
      node.checkedNodes.forEach((item) => {
        this.question.knowledgePoints.push({
          knowledgePointId: item.id,
          // name: this.getFullNodeName(item.pathIds, 'knowTree') || item.name,
          name: item.name,
          pathIds: item.pathIds
        })
      })
      // this.changeMatchChecked()
      this.$emit("DisassemblyReviewDetail",this.question.knowledgePoints)
    },
    // 改变推荐选中，同步到el-tag框和树
    handleMatchKnowChange () {
      let that = this
      // 比对e-tags框内的已选知识点和推荐列表相同的点，先删除后添加
      _.each(this.matchKnowList, (item) => {
        _.remove(that.question.knowledgePoints, function (i) {
          return i.knowledgePointId === item.knowledgePointId
        })
      })
      for (let i of this.matchCheckedKnow) {
        that.question.knowledgePoints.push({
          knowledgePointId: i.knowledgePointId,
          name: i.name,
          pathIds: i.pathIds
        })
      }
      this.$forceUpdate()
      console.log();
    },
    // 处理后台传输的可能相符的知识点数据
    initMatchKnow () {
      // this.$http.get(paperMag.getMatchKnows, {questionId: this.questionId}).then((resp) => {
      //   this.matchKnowList = []
      //   this.matchCheckedKnow = []
      //   let that = this
      //   resp.forEach((d) => {
      //     that.matchKnowList.push({
      //       knowledgePointId: d.id,
      //       name: d.pathsName,
      //       pathIds: d.paths
      //     })
      //   })
      //   // 如果初始化的时候当前试题有选中的知识点
      //   // this.changeMatchChecked()
      // }).catch((err) => {
      //   this.$message.error(err.msg)
      // })
    },
    handleClick (value) {
      if (typeof value === 'boolean') {
        this.showKnowTree = value
        return;
      }
      this.showKnowTree = !this.showKnowTree
    },
    // 选择树节点，获取到带有所有层级的name
    getFullNodeName (pathIds, treeName) {
      let fullName = ''
      let that = this
      // 针对有的pathIds以,结尾有的没有做处理
      if (!pathIds) {
        return fullName;
      }
      let pathIdsArr = pathIds.split(',')
      if (!pathIdsArr[pathIdsArr.length - 1]) {
        pathIdsArr.pop()
      }
      _.forEach(pathIdsArr, (value, index) => {
        if (index === (pathIdsArr.length - 1)) {
          that.$refs[treeName].getNode(value) && (fullName += that.$refs[treeName].getNode(value).data.name)
        } else {
          that.$refs[treeName].getNode(value) && (fullName += that.$refs[treeName].getNode(value).data.name + ' > ')
        }
      })
      return fullName
    },
    // 根据目前所选择的知识点，同步改变可能相符的列表勾选
    changeMatchChecked () {
      let _this = this
      this.matchCheckedKnow = this.matchKnowList.filter(function (item, index) {
        let checked = false
        for (let know of _this.question.knowledgePoints) {
          if (item.knowledgePointId === know.knowledgePointId) {
            checked = true
          }
        }
        return checked
      })
    }
  },
  components: {
    [Tag.name]: Tag,
    [Tree.name]: Tree
  }
}
</script>

<style lang="scss" scoped>
.out-checkKnows {
  .tree-tag-wrap {
    .knows-scroll-box {
      position: relative;
      max-height: 200px;
    }
  }
  .suggest-wrapper {
    background: #fff;
    .title {
      padding: 0 10px;
      margin-top: 10px;
      border: 1px solid #dcdfe6;
      line-height: 32px;
      color: #ffffff;
      background: #fd8080;
    }
    .list {
      padding: 10px;
      border: 1px solid #dcdfe6;
      border-top: none;
      line-height: 26px!important;
    }
  }
}
</style>
<style lang="scss">
.out-checkKnows {
  .suggest-wrapper {
    .el-checkbox__label {
      white-space: pre-wrap;
      vertical-align: text-top;
    }
    .el-checkbox {
      margin-right: 0px;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/components/check-knows.vue